export default {"src":"/venues/_next/static/media/hero-search.7c97ab0d.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};